import { FormattedMessage, useIntl } from 'react-intl'

import { RulesCard } from '@/pages/promotion/components/rules-card'
import { RulesList } from '@/pages/promotion/components/rules-list'

export const FlipOutsRules = () => {
  const { messages } = useIntl()
  const raw = messages['promo.allInFlipOuts.rules.description'] as unknown
  const rules = Array.isArray(raw) ? (raw as string[]) : []

  if (!rules.length) {
    return null
  }

  return (
    <div className="mt-6">
      <RulesCard title={<FormattedMessage id="promo.allInFlipOuts.rules.title" />}>
        <RulesList rules={rules} />
      </RulesCard>
    </div>
  )
}
